import type { Meeting } from "@sgdf/client";

export function isOpenMeeting(meeting: Meeting) {
  return meeting.status === "open";
}

export function isNotOpenMeeting(meeting: Meeting) {
  return meeting.status !== "open";
}
